function missingFilter() {
  return function missing(input) {
    if (input === '' || input === null || input === undefined) {
      return '-';
    } else {
      return input;
    }
  };
}

export default missingFilter;



/** WEBPACK FOOTER **
 ** ./src/app/filters/missing.filter.js
 **/